import './_style.scss';
import React, {Component} from 'react';
import * as PropTypes from 'prop-types';
import holdCursorPosition from "../../../helpers/formUtils";

class CharCountTextarea extends Component {

    static propTypes = {
        className: PropTypes.string,
        leftFooterContent: PropTypes.object,
        maxLength: PropTypes.number,
        name: PropTypes.string,
        onChange: PropTypes.func,
        rows: PropTypes.number,
        value: PropTypes.string,
    };

    static defaultProps = {
        leftFooterContent: '',
        maxLength: 5000,
        rows: 5
    };

    constructor(props) {
        super(props);
        this.state = {
            charsUsed: props.value.length
        };
    }

    handleChange(event) {
        holdCursorPosition(event);
        this.setState({charsUsed: event.target.value.length});
        if (this.props.onChange !== undefined) this.props.onChange(event);
    }

    render() {
        const {className, maxLength, name, rows, value, leftFooterContent} = this.props;
        return (
            <div className="char-count-textarea">
                <textarea className={className}
                          name={name}
                          value={value}
                          maxLength={maxLength}
                          rows={rows}
                          onChange={this.handleChange.bind(this)}/>
                <div className="char-count-textarea-footer level">
                    <div className="textarea-footer-left">
                        {leftFooterContent}
                    </div>
                    <div className="char-count-value is-pulled-right">
                        {this.state.charsUsed}/{this.props.maxLength}
                    </div>
                </div>
            </div>
        );
    }
}

export default CharCountTextarea;
